import { render, staticRenderFns } from "./AdvertisementBenefitSelection.vue?vue&type=template&id=220c8843&"
import script from "./AdvertisementBenefitSelection.vue?vue&type=script&lang=js&"
export * from "./AdvertisementBenefitSelection.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementBenefitSelection.vue?vue&type=style&index=0&id=220c8843&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports